{
  "OptionsMenuTitle": "Mostra le opzioni disponibili per questo sottoreport del dashboard.",
  "DashboardDraggableTitle": "Trascinare questo report su un altro in questo cruscotto per scambiarlo.",
  "OptionsMenuRemove": "Rimuovi rapporto",
  "OptionsMenuAdd": "Creare un nuovo rapporto",
  "OptionsMenuModify": "Modificare il rapporto",
  "OptionsMenuChange": "Rapporto Switch",
  "OptionsMenuChoose": "Scegliere il rapporto",
  "OptionMenuUpdateReportError": "Si è verificato un errore nel tentativo di aggiornare il report del cruscotto.",
  "OptionMenuRemovePermDelete": "Cancellare definitivamente questo rapporto",
  "NAME": "DashboardOptions"
}